module.exports = __webpack_public_path__ + "static/media/ico-wallet-dark.c6135fa7.svg";